import dayjs from "dayjs";

/**
 * Formats a date string or Date object into DD/MM/YYYY format.
 * @param {string|Date} date - The date to format.
 * @returns {string} The formatted date string, or an empty string if invalid.
 */
export const formatDate = (date) => {
    if (!date) return "";
    const parsedDate = dayjs(date);
    if (!parsedDate.isValid()) return "";
    return parsedDate.format("DD/MM/YYYY");
};

/**
 * Formats a date string or Date object into DD/MM/YYYY HH:mm format.
 * @param {string|Date} date - The date to format.
 * @returns {string} The formatted date and time string.
 */
export const formatDateTime = (date) => {
    if (!date) return "";
    const parsedDate = dayjs(date);
    if (!parsedDate.isValid()) return "";
    return parsedDate.format("DD/MM/YYYY HH:mm");
};
